/* eslint-disable linebreak-style */
/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */
/* eslint-disable react/no-array-index-key */

import React from 'react';
import { Fade } from 'react-awesome-reveal';

import { TeamMembers } from 'json/landingPageData';
import Button from '../elements/Button';

// Render whatever is in TeamMembers (founder + open role placeholders).
// Cap at 6 items for the landing preview; the full team page lists everyone.
export default function TeamPreview() {
  const previewMembers = TeamMembers.slice(0, 6);

  return (
    <section className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="container mx-auto px-4">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
          {/* Left Content */}
          <div className="lg:w-1/2">
            <Fade direction="left" triggerOnce>
              <p className="text-sm font-medium text-theme-purple uppercase tracking-wider mb-3">
                Meet the team
              </p>
              <h2 className="text-4xl md:text-5xl text-theme-blue font-serif font-bold mb-6">
                Cleveland-rooted,
                <br />
                <span className="text-theme-purple">mentor-first.</span>
              </h2>
              <p className="text-lg text-gray-500 mb-8 leading-relaxed">
                Balance Point Studios was founded by Allison Black in 2023. As the
                organization grows, we are building a team of mentors, artists, and
                program staff who all share one belief: every young person deserves a
                space to be seen and to grow.
              </p>

              {/* Snapshot stats */}
              <div className="grid grid-cols-3 gap-6 mb-8">
                <div>
                  <p className="text-3xl font-serif font-bold text-theme-blue">2023</p>
                  <p className="text-sm text-gray-500">Founded</p>
                </div>
                <div>
                  <p className="text-3xl font-serif font-bold text-theme-blue">1</p>
                  <p className="text-sm text-gray-500">Neighborhood</p>
                </div>
                <div>
                  <p className="text-3xl font-serif font-bold text-theme-blue">Growing</p>
                  <p className="text-sm text-gray-500">By design</p>
                </div>
              </div>

              <Button
                href="/team"
                type="link"
                className="inline-flex items-center px-6 py-3 text-theme-purple font-medium border-2 border-theme-purple rounded-xl hover:bg-theme-purple hover:text-white transition-all duration-300 cursor-pointer"
              >
                Meet the full team
                <svg className="w-5 h-5 ml-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </Button>
            </Fade>
          </div>

          {/* Right - Team Grid */}
          <div className="lg:w-1/2">
            <Fade direction="right" triggerOnce>
              <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                {previewMembers.map((member, index) => (
                  <Fade key={`${member.name}-${index}`} direction="up" delay={index * 100} triggerOnce>
                    <div className="group relative overflow-hidden rounded-2xl cursor-pointer">
                      <div className="aspect-[3/4] overflow-hidden">
                        <img
                          src={member.imageUrl}
                          alt={member.name}
                          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                        />
                      </div>

                      {/* Hover overlay */}
                      <div className="absolute inset-0 bg-gradient-to-t from-theme-blue/90 via-theme-blue/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                        <div className="absolute bottom-0 left-0 right-0 p-4">
                          <p className="text-white font-semibold">{member.name}</p>
                          <p className="text-white/80 text-sm">{member.position}</p>
                        </div>
                      </div>

                      {/* Default name badge */}
                      <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3 group-hover:opacity-0 transition-opacity duration-300">
                        <p className="text-white text-sm font-medium">{member.name}</p>
                        <p className="text-white/70 text-xs">{member.position}</p>
                      </div>
                    </div>
                  </Fade>
                ))}
              </div>
            </Fade>
          </div>
        </div>
      </div>
    </section>
  );
}
